import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { debug } from 'console';
import { Guid } from 'guid-typescript';
import { AuthService } from 'src/app/Services/auth.service';
import { CommonService } from "src/app/Services/common.service";

@Component({
  selector: 'app-steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.scss']
})
export class StepsComponent implements OnInit {

  @Input() stepHeading: string;
  @Input() stepCounter: number;
  minorcomp: boolean = false;
  minor: boolean = false;
  actype: string;

  constructor(public auth: AuthService,
    private commonP: CommonService,

  ) { }

  async ngOnInit() {
    // this.commonP.presentLoading();

    this.actype = await this.commonP.Get('accountType');
    this.minorcomp = this.auth?.data?.onBoardingAccount?.minorcomplete == true ? true : false;
    console.log("getacountforminorcomp", this.actype);

    console.log("getacountforminorcomphellow", this.minorcomp);
    debugger
    switch (this.actype) {

      case "M" || this.minorcomp != true:

        await this.getMinor();
        break;
    }
  }
  async getMinor() {
    debugger
    let token = await this.commonP.Get("token");
    console.log(token, "token")
    this.commonP.presentLoading();
    let body = {
      uniqueid: Guid.create().toString()
    }
    this.auth.getminorcomp(token, body).then((data: any) => {
      switch (data?.response?.code) {
        case 1:
          debugger
          this.minor = data?.response?.content
          console.log("minor", this.minor);

          this.commonP.hideLoading();
          break;
        case 7:
          this.commonP.showErrorAlert("Error", data?.response?.error?.content?.message, "OK", null);
          this.commonP.hideLoading();
          break;
      }
    })
  }

}
